<template>
  <div
    class="AuthRegister"
    data-cy-id="register-stage-job-roles"
    data-rmpdev-selector="update-user-form"
  >
    <h1 class="u-noMargin">
      Job Preferences
    </h1>
    <p>Receive opportunities catered to your preference</p>

    <transition>
      <div
        v-if="serverValidationErrors.fail"
        class="Notice Notice--danger"
      >
        <div class="Notice-copy">
          {{ serverValidationErrors.fail }}
        </div>
      </div>
    </transition>
    <div
      class="Form-field"
    >
      <h3 class="Form-label">
        Job role(s) interested in
      </h3>
      <embedded-tag-selector
        v-model="fields.jobRoles"
        data-cy-id="register-job-roles"
        :available-tags="jobRoles"
        :is-searchable="true"
        :search-keys="['name']"
        data-rmpdev-field-selector="jobRoles"
      />
      <error-messages
        :manual-validate="validateAll"
        :errors="validateStatus({ field: v$.fields.jobRoles, serverKey: 'jobRoles', label: 'Roles' }).errors"
      />
    </div>
    <button
      :class="['Button Button--green Button--long', {'spinner' : ui.loading}]"
      data-cy-id="register-next"
      @click.prevent="updateUser"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { required } from '@vuelidate/validators';
import EmbeddedTagSelector from '@/components/user-roles/src-alt/embedded-selector.vue';
import ErrorMessages from '@/components/form/partials/error-message.vue';
import useVuelidate from '@vuelidate/core';
import RegistrationStagesMixin from './registration-stages-mixin';

export default {
  components: {
    ErrorMessages,
    EmbeddedTagSelector,
  },
  mixins: [RegistrationStagesMixin],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      fields: {
        jobRoles: [],
      },
    };
  },
  validations() {
    const rules = {
      fields: {
        jobRoles: {
          required,
        },
      },
    };

    return rules;
  },
  computed: {
    ...mapState('entities', {
      jobRoles: (state) => state.jobRoles,
    }),
    updatePayload() {
      return {
        jobRoles: this.fields.jobRoles.map((item) => item.slug),
      };
    },
  },
  mounted() {
    this.getJobRoles().then(() => {
      this.fields.jobRoles = this.user.jobRoles;
    });
  },
  methods: {
    ...mapActions('entities', {
      getJobRoles: 'getJobRoles',
    }),
  },
};
</script>
<style scoped>
.Form-field Button {
  width: 100%;
}
</style>
